export default __webpack_public_path__ + "static/media/i-scan_bcr.127be4b9.svg";